import { WebphoneCallState } from '@modules/SoftPhoneModule/types';
import CallControls from './components/CallControls';
import { useCallBarProps } from './hooks/useCallBarProps';

interface CallBarProps {
  callState: WebphoneCallState;
  show: boolean;
}

export function CallBar({ callState, show }: Readonly<CallBarProps>) {
  const callBarProps = useCallBarProps(callState, show);

  if (!callBarProps) {
    return null;
  }

  return <CallControls {...callBarProps} />;
}
